import React from 'react';
import { Modal, Box, Typography, Button } from '@mui/material';

interface SessionExpiredModalProps {
  open: boolean;
  onRedirect: () => void;
}

const style = {
  position: 'absolute' as const,
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
  textAlign: 'center',
};

const SessionExpiredModal: React.FC<SessionExpiredModalProps> = ({ open, onRedirect }) => {
  return (
    <Modal
      open={open}
      aria-labelledby="session-expired-modal-title"
      aria-describedby="session-expired-modal-description"
      disableEscapeKeyDown
    >
      <Box sx={style}>
        <Typography id="session-expired-modal-title" variant="h6" component="h2" color="error">
          Session Expired
        </Typography>
        <Typography id="session-expired-modal-description" sx={{ mt: 2 }}>
          Your session has expired for security reasons. Please log in again to continue using the application.
        </Typography>
        <Button variant="contained" onClick={onRedirect} sx={{ mt: 3 }} color="primary" fullWidth>
          Log In Again
        </Button>
      </Box>
    </Modal>
  );
};

export default SessionExpiredModal;
